<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <tabs
      v-else-if="!this.loading && !this.errormessage"
      pills
      type="primary"
      icons
      centered
      value="position"
    >
      <tab-pane
        id="position"
        key="position"
      >
        <span slot="title">
          <div class="row align-items-center">
            <div class="content-heading">Staff Positions</div>
          </div>
        </span>
        <card class="mt-3">
          <div v-if="rowData.length > 0">
            <div class="d-none d-md-block">
              <el-table
                :data="rowData"
                header-row-class-name="text-danger"
                :row-class-name="leadershipStyle"
                size="small"
                :header-cell-style="headerCellStyle"
                :cell-style="cellStyle"
                @cell-click="onCellClick"
              >
                <el-table-column
                  label="Position"
                  property="Position"
                />
                <el-table-column
                  label="Name"
                  property="FullName"
                  label-class-name="text-danger"
                  class-name="text-primary pointer"
                />
                <el-table-column
                  class-name="d-none d-md-table-cell text-primary pointer"
                  label-class-name="text-danger"
                  label="Email"
                >
                  <template slot-scope="props">
                    <a :href="'mailto:' + props.row.EmailAddress">{{ props.row.EmailAddress }}</a>
                  </template>
                </el-table-column>
                <el-table-column
                  class-name="d-none d-md-table-cell"
                  label="Phone"
                  property="PhoneNumber"
                  width="100px"
                />
                <el-table-column
                  class-name="d-none d-md-table-cell"
                  label="Critter"
                  property="PersonalCritter"
                  width="100px"
                />
                <el-table-column
                  label="First Time?"
                  class-name="d-none d-md-table-cell text-center"
                  width="100px"
                >
                  <template slot-scope="props">
                    <span
                      class="h6"
                      :class="{ 'text-success': props.row.FirstTimeStaff }"
                    >{{ firstTimeText(props.row.FirstTimeStaff) }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="d-block d-md-none">
              <el-table
                :data="rowData"
                header-row-class-name="text-danger"
                :row-class-name="leadershipStyle"
                size="small"
                :header-cell-style="headerCellStyle"
                :cell-style="cellStyle"
                @cell-click="onCellClick"
              >
                <el-table-column
                  label="Position"
                  property="Position"
                />
                <el-table-column
                  label="Name"
                  property="FullName"
                  label-class-name="text-danger"
                  class-name="text-primary pointer"
                />
              </el-table>
            </div>
          </div>
          <div
            v-else
            class="text-center"
          >
            <p class="card-category">
              There are no staff members assigned to this course.
            </p>
          </div>
        </card>
      </tab-pane>
      <tab-pane
        id="member"
        key="member"
      >
        <span slot="title">
          <div class="row align-items-center">
            <div class="content-heading">Staff Members</div>
          </div>
        </span>
        <scouter-list scouter-type="staff" />
      </tab-pane>
    </tabs>
  </div>
</template>

<script>
import staffMemberPositionApi from '@/services/api/staff-member-position'
import oops from '@/components/_main/oops.vue'
import Tabs from '@/plugins/paper-components/tabs/tabs.vue'
import TabPane from '@/plugins/paper-components/tabs/tab.vue'
import ScouterList from '@/components/scouters/scouter-list.vue'

export default {
  name: 'StaffList',
  components: {
    oops,
    Tabs,
    TabPane,
    ScouterList
  },
  data: function () {
    return {
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyle: {
        padding: '0',
        height: '20px',
        'font-size': '10px',
        'text-align': 'center',
        'overflow-wrap': 'break-word'
      },
      rowData: null,
      loading: true,
      errormessage: null
    }
  },
  mounted () {
    staffMemberPositionApi
      .listStaffPositions(this.$root.courseKey)
      .then(x => {
        this.rowData = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    firstTimeText: function (firstTime) {
      return firstTime ? 'Yes' : 'No'
    },
    onCellClick: function (row, column, cell, event) {
      this.tempHolder = { c: cell, r: row, co: column, e: event }
      if (column.label === 'Name') {
        const path = '/staff/participant?s=' + row.ScouterKey + '&r=staff'
        this.$router.push(path)
      }
    },
    leadershipStyle: function (props) {
      if (props.row.IsLeader) {
        return 'leaderRow'
      } else {
        return ''
      }
    }
  }
}
</script>
<style scoped>
.leaderRow {
  font-weight: 900;
}
</style>
